<template>
  <div>
    <div class="active-lot-detail cursor-pointer-div" v-for="lot in lotList" :key="lot.id" @click="toLotDetail(lot)">
      <span class="active-lot-sort">
        {{lot.sort}}
      </span>
      <img class="active-lot-img" :src="(lot.lotImg && lot.lotImg.length > 0) ? lot.lotImg[0].link : ''">
      <span class="active-lot-name">{{lot.lotName}}</span>
      <span v-if="lot.auctionStatus!=null" class="active-lot-time-right" :class="getStatusClass(lot.auctionHallLotStatus, lot.backOutStatus)">
        {{getAuctionStatusText(lot.auctionHallLotStatus, lot.backOutStatus)}}</span>
      <div>
        <span v-if="lot.auctionStatus!=null" class="active-lot-label-status">{{lot.auctionStatus==0?'起拍价':(lot.auctionStatus==1?'当前价':lot.auctionStatus==2?'当前价':lot.auctionStatus==10?'起拍价':
          (lot.auctionStatus==3?'成交价':"当前价"))}}：</span>
        <span  
          class="acitve-lot-price" >¥{{lot.auctionStatus==0?parseFloat(lot.startPrice).toFixed(2):parseFloat(lot.currentQuoted).toFixed(2)}}</span>
      </div>
      <div class="active-lot-time-div">
        <span class="active-lot-time-left">
          <!-- <span class="active-lot-time-plan" v-if="lot.auctionStatus==0">预计&nbsp;</span> -->
          <span class="active-lot-time-status">{{lot.auctionStatus==-1||lot.auctionStatus==3 ? '结束时间：' + lot.endTime :lot.auctionStatus==1 ? '距离结束还有：' + formatCountdown(getCountdownValue(lot.id)) : lot.auctionStatus==2 ? '距离结束还有：' + lot.timeRemainingStr : meetingData.startAuctionTime?  '开始时间：' + meetingData.startAuctionTime :  '开始时间：' + lot.startAuctionTime}}</span>

          
          <!-- <span class="active-lot-time-status">{{lot.auctionStatus==-1||lot.auctionStatus==3? lot.auctionStatus==1 ? '剩余时间：' + meetingData.timeRemainingStr : meetingData.startAuctionTime? '开始时间：' + meetingData.startAuctionTime : '开始时间：'+lot.startAuctionTime}}</span> -->
        </span>
      </div>
        <div class="active-lot-stats">
          <span class="stat-item">{{lot.viewCount}}次围观</span>
          <span class="stat-item" v-if="lot.auctionStatus!=0">{{lot.bidCount}}次出价</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotDivView',
  props: ['lotList', 'meetingData'],
  data() {
    return {
      countdownTimers: {}, // 存储每个标的的倒计时定时器
      countdownValues: {} // 存储每个标的的倒计时值
    }
  },
  watch: {
    lotList: {
      handler() {
        this.startCountdowns();
      },
      deep: true
    }
  },
  mounted() {
    this.startCountdowns();
  },
  beforeDestroy() {
    this.clearAllTimers();
  },
    methods: {    
    toLotDetail(lot){
      this.$router.push({path: "/lotDetail", query: {lotId: lot.id}})
    },
    
        
    getCountdownValue(lotId) {
      return this.countdownValues[lotId] !== undefined ? this.countdownValues[lotId] : 0;
    },
    
    startCountdowns() {
      // 清理现有的定时器
      this.clearAllTimers();
      
      // 重置 countdownValues
      this.countdownValues = {};
      
      // 为每个标的启动倒计时（仅 auctionStatus == 1 的状态）
      if (this.lotList && this.lotList.length > 0) {
        this.lotList.forEach(item => {
          if (item.auctionStatus == 1 && item.timeRemaining && item.timeRemaining > 0) {
            // 使用 $set 确保响应式
            this.$set(this.countdownValues, item.id, item.timeRemainingStr);
            this.startSingleCountdown(item.id);
          } else {
            this.$set(this.countdownValues, item.id, item.timeRemainingStr || 0);
          }
        });
      }
    },
    
    startSingleCountdown(lotId) {
      const item = this.lotList ? this.lotList.find(b => b.id === lotId) : null;
      if (!item || item.auctionStatus != 1 || this.countdownValues[lotId] <= 0) {
        return;
      }
      
      this.countdownTimers[lotId] = setInterval(() => {
        // console.log("startSingleCountdown", lotId, this.countdownValues[lotId])
        if (this.countdownValues[lotId] > 0) {
          // 使用 $set 确保 Vue 能检测到变化
          this.$set(this.countdownValues, lotId, this.countdownValues[lotId] - 1);
        } else {
          // 倒计时结束，清理定时器
          this.clearTimer(lotId);
        }
      }, 1000);
    },
    
    clearTimer(lotId) {
      if (this.countdownTimers[lotId]) {
        clearInterval(this.countdownTimers[lotId]);
        delete this.countdownTimers[lotId];
      }
    },
    
    clearAllTimers() {
      Object.keys(this.countdownTimers).forEach(lotId => {
        this.clearTimer(lotId);
      });
    },
    
    formatCountdown(timeSeconds) {
      if (timeSeconds <= 0) {
        return '--';
      }
      
      const days = Math.floor(timeSeconds / (24 * 60 * 60));
      const hours = Math.floor((timeSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((timeSeconds % (60 * 60)) / 60);
      const seconds = timeSeconds % 60;
      
      let result = '';
      if (days > 0) {
        result += `${days}天`;
      }
      if (hours > 0 || days > 0) {
        result += `${hours.toString().padStart(2, '0')}:`;
      }
      result += `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      
      return result;
    },
    getStatusBottomClass(status, backOutStatus) {
      if (status == 10) return 'bottom-badge-registering';
      if (status == 0) return 'bottom-badge-not-started';
      if (status == 1) return 'bottom-badge-auctioning';
      if (status == 2) return 'bottom-badge-paused';
      if (status == 3) return 'bottom-badge-completed';
      if (backOutStatus == 1) return 'bottom-badge-withdrawn';
      if (status == -1) return 'bottom-badge-failed';
      return 'bottom-badge-ended';
    },
    getAuctionStatusText(status, backOutStatus) {
    //   if (status == 0) return '报名中';
      if (status == 10) return '报名中';
      if (status == 11) return '拍卖中';
      if (status == 12) return '正在竞价';
      if (status == 2) return '竞价暂停';
      if (status == 13) return '竞价截止';
      if (status == 3) return '已成交';
      if (status == -1) return '已流拍';
      if (backOutStatus == 1) return '已撤拍';
      return '未开始';
    },
    getStatusClass(status, backOutStatus) {
      if (status == 10) return 'status-registering';
      if (status == 0) return 'status-ended';
      if (status == 11) return 'status-auctioning';
      if (status == 12) return 'status-bidding';
      if (status == 2) return 'status-paused';
      if (status == 13) return 'status-ended-bidding';
      if (status == 3) return 'status-completed';
      if (backOutStatus == 1) return 'status-withdrawn';
      if (status == -1) return 'status-failed';
      return 'status-ended';
    },
  }
}
</script>

<style>
  .active-lot-bottom-span{
    display: inline-block;
    margin: 20px 10px 10px 10px;
    width: 66px;
    height: 18px;
    opacity: 1;
    /** 文本1 */
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 17.38px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
  .active-lot-time-right{
    display: inline-block;
    width: 60px;
    height: 24px;
    opacity: 1;
    margin-top: 8px;
    border-radius: 20px 0px 0px 20px;
    background: rgba(214, 54, 59, 1);

    opacity: 1;
    /** 文本1 */
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
  .active-lot-time-status{
    display: inline-block;
    /* margin-left: 10px; */
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(102, 102, 102, 1);
  }
  .active-lot-time-plan{
    /** 文本1 */
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(0, 0, 0, 1);
  }
  .active-lot-time-left{
    display: inline-block;
    width: 240px;
  }
  .active-lot-time-div{
    margin-top: 5px;
    margin-left: 10px;
    height: 24px;
  }
  .active-lot-label-status{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(102, 102, 102, 1);
  }

  .acitve-lot-price{
    display: inline-block;
    margin-left: 5px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(102, 102, 102, 1);
  }
  .active-lot-name{
    margin: 10px 10px 10px;
    display: inline-block;
    width: 74.2%;
    height: 21px;
    opacity: 1;
    /** 文本1 */
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(0, 0, 0, 1);
    vertical-align: top;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .active-lot-img{
    width: 310px;
    height: 190px;
    opacity: 1;
    margin-top: -24px;
  }
  .active-lot-sort{
    position: relative;
    display: inline-block;
    width: 36px;
    height: 24px;
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;

    /** 文本1 */
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
  .cursor-pointer-div:hover{
    cursor: pointer;
    box-shadow: 0px 4px 10px  rgba(0, 0, 0, 0.35);
  }
  .active-lot-detail{
    display: inline-block;
    width: 310px;
    height: 330px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    margin-right: 20px;
    margin-top: 20px;
  }
.active-lot-stats {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.stat-item {
  margin: 0 3px;
  flex: 1;
  text-align: center;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
  height: 26px;
  background: #f2f2f2;
}
.bottom-badge-registering {
  background: #1890ff;
}

.bottom-badge-not-started {
  background: #52c41a;
}

.bottom-badge-auctioning {
  background: #ff7f00;
}

.bottom-badge-paused {
  background: #d6363b;
}

.bottom-badge-completed {
  background: #73d13d;
}

.bottom-badge-withdrawn,
.bottom-badge-failed,
.bottom-badge-ended {
  background: #bfbfbf;
}


.bottom-badge-registering {
  background: #1890ff;
}

.bottom-badge-not-started {
  background: #52c41a;
}

.bottom-badge-auctioning {
  background: #fa8c16;
}

.bottom-badge-bidding {
  background: #ff7f00;
}

.bottom-badge-paused {
  background: #d9d9d9;
}

.bottom-badge-ended-bidding {
  background: #bfbfbf;
}

.bottom-badge-completed {
  background: #52c41a;
}

.bottom-badge-withdrawn,
.bottom-badge-failed {
  background: #8c8c8c;
}

.bottom-badge-ended {
  background: #bfbfbf;
}

.status-registering {
  background: #1890ff;
}

.status-auctioning {
  background: #f59a23;
}

.status-bidding {
  background: #d9001b;
}

.status-paused {
  background: #aaaaaa;
}

.status-ended-bidding {
  background: #aaaaaa;
}

.status-completed {
  background: #52c41a;
}

.status-withdrawn,
.status-failed {
  background: #555555;
}

.status-ended {
  background: #bfbfbf;
}

</style>